import React, { useState } from "react";
import { Link } from "react-router-dom";

interface ProductCardProps {
  product: {
    id: string | number;
    name: string;
    description?: string;
    price: string | number;
    images?: {
      id?: number;
      signedUrl: string;
      isPrimary: boolean;
    }[];
  };
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const [imageError, setImageError] = useState(false);

  // Pick primary image first, fallback to first image
  const imageUrl =
    product.images?.find((img) => img.isPrimary)?.signedUrl ||
    product.images?.[0]?.signedUrl;

  // Short description (first 10 words)
  const shortDesc = product.description
    ? product.description.split(" ").slice(0, 10).join(" ") +
      (product.description.split(" ").length > 10 ? "..." : "")
    : "No description";

  return (
    <Link
      to={`/product/${product.id}`}
      className="block text-inherit hover:no-underline"
    >
      <div className="flex flex-col items-center text-center bg-white rounded-xl p-1 shadow-sm transition-transform duration-200 hover:translate-y-[-3px] hover:shadow-md">
        <div className="w-full h-44 rounded-lg overflow-hidden bg-gray-100 flex justify-center items-center mb-3">
          {imageUrl && !imageError ? (
            <img
              src={imageUrl}
              alt={product.name}
              onError={() => setImageError(true)}
              className="w-full h-full object-cover"
              loading="lazy"
              crossOrigin="anonymous"
            />
          ) : (
            <div className="w-full h-full bg-gray-300 flex justify-center items-center text-gray-500 text-sm rounded-lg">
              No Image
            </div>
          )}
        </div>

        <h3 className="text-base font-semibold text-gray-800 truncate mb-1">
          {product.name}
        </h3>
        <p className="text-sm text-gray-500 truncate mb-2">{shortDesc}</p>
        <p className="text-base font-semibold text-gray-900 mt-auto">
          UGX {Number(product.price).toLocaleString()}
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;
